webpackJsonp([0],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(37);
var common_1 = __webpack_require__(52);
var http_1 = __webpack_require__(82);
var app_component_1 = __webpack_require__(323);
var index_component_1 = __webpack_require__(324);
var slick_slider_component_1 = __webpack_require__(325);
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
AppModule = __decorate([
    core_1.NgModule({
        imports: [
            platform_browser_1.BrowserModule,
            common_1.CommonModule,
            http_1.HttpModule
        ],
        declarations: [app_component_1.AppComponent, index_component_1.IndexComponent, slick_slider_component_1.SlickSliderComponent],
        bootstrap: [app_component_1.AppComponent]
    })
], AppModule);
exports.AppModule = AppModule;


/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(25);
var map_1 = __webpack_require__(315);
Observable_1.Observable.prototype.map = map_1.map;
//# sourceMappingURL=map.js.map

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(25);
var toPromise_1 = __webpack_require__(316);
Observable_1.Observable.prototype.toPromise = toPromise_1.toPromise;
//# sourceMappingURL=toPromise.js.map

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(128);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    if (typeof project !== 'function') {
        throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
    }
    return this.lift(new MapOperator(project, thisArg));
}
exports.map = map;
var MapOperator = (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
exports.MapOperator = MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapSubscriber = (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=map.js.map

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(81);
/* tslint:disable:max-line-length */
/**
 * @param PromiseCtor
 * @return {Promise<T>}
 * @method toPromise
 * @owner Observable
 */
function toPromise(PromiseCtor) {
    var _this = this;
    if (!PromiseCtor) {
        if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
            PromiseCtor = root_1.root.Rx.config.Promise;
        }
        else if (root_1.root.Promise) {
            PromiseCtor = root_1.root.Promise;
        }
    }
    if (!PromiseCtor) {
        throw new Error('no Promise impl found');
    }
    return new PromiseCtor(function (resolve, reject) {
        var value;
        _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
    });
}
exports.toPromise = toPromise;
//# sourceMappingURL=toPromise.js.map

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var AppComponent = (function () {
    function AppComponent() {
    }
    return AppComponent;
}());
AppComponent = __decorate([
    core_1.Component({
        selector: 'my-app',
        template: "\n        <app-index></app-index>\n    "
    })
], AppComponent);
exports.AppComponent = AppComponent;


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(37);
var route_service_1 = __webpack_require__(327);
var IndexComponent = (function () {
    function IndexComponent(zone, routeService, sanitizer) {
        var _this = this;
        this.zone = zone;
        this.routeService = routeService;
        this.sanitizer = sanitizer;
        this.MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        this.map = null;
        this.iconFile = '/fileadmin/template/assets/img/pin-grey.png';
        this.zIndex = 100;
        this.timelineEvents = [];
        this.progress = 0;
        this.period = "";
        this.months = [];
        this.name = "";
        this.slides = [];
        this.routesVM = [];
        this.safeProgress = this.sanitizer.bypassSecurityTrustStyle("scaleX(0.5)");
        this.selectMarker = function (waypoint, index, count, routename) {
            _this.zone.run(function () {
                // the scale
                var scaling = 0;
                if (index != 0) {
                    scaling = (1 / count * (index + 1));
                }
                _this.safeProgress = _this.sanitizer.bypassSecurityTrustStyle("scaleX(" + scaling + ")");
                // slides
                _this.slides = waypoint.slides;
                // timelinepoints
                for (var _a = 0, _b = _this.timelineEvents; _a < _b.length; _a++) {
                    var timelineEvent = _b[_a];
                    timelineEvent.selected = waypoint.months.indexOf(timelineEvent.number) !== -1;
                }
                // text
                var startMonth = _this.MONTHS[waypoint.months[0]];
                var endMonth = _this.MONTHS[waypoint.months[waypoint.months.length - 1]];
                if (waypoint.months.length === 1) {
                    _this.period = startMonth + " " + waypoint.startyear;
                }
                else if (waypoint.startyear === waypoint.endtyear) {
                    _this.period = startMonth + " - " + endMonth + " " + waypoint.startyear;
                }
                else {
                    _this.period = startMonth + " " + waypoint.startyear + " - " + endMonth + " " + waypoint.endtyear;
                }
                // name
                _this.name = waypoint.name;
                // select the right route
                for (var _c = 0, _d = _this.routesVM; _c < _d.length; _c++) {
                    var routeVM = _d[_c];
                    routeVM.selected = (routeVM.name == routename);
                }
            });
        };
    }
    IndexComponent.prototype.drawRout = function (route) {
        var _this = this;
        var createmarker = function (waypoint, index, count) {
            var cordiante = new google.maps.LatLng(waypoint.cordinate.lat, waypoint.cordinate.lng);
            if (waypoint.color == 1) {
                console.log(waypoint);
                _this.iconFile = '/fileadmin/template/assets/img/pin-pink.png';
                _this.zIndex = 9999;
            }
            else {
                _this.iconFile = '/fileadmin/template/assets/img/pin-grey.png';
                _this.zIndex = 100;
            }
            var marker = new google.maps.Marker({
                position: cordiante,
                map: _this.map,
                icon: _this.iconFile,
                optimized: false,
                zIndex: _this.zIndex
            });
            marker.addListener('click', function () {
                _this.selectMarker(waypoint, index, count, route.name);
            });
        };
        var waypoints = [];
        // start and end point
        for (var i = 0; i < route.waypoints.length; i++) {
            waypoints.push(route.waypoints[i].cordinate);
            createmarker(route.waypoints[i], i, route.waypoints.length);
        }
        var flightPath = new google.maps.Polyline({
            path: waypoints,
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 2
        });
        flightPath.setMap(this.map);
    };
    IndexComponent.prototype.centerRoute = function (routeVM) {
        var _this = this;
        console.log("centerRoute %o", routeVM);
        this.map.setCenter(routeVM.center);
        this.map.setZoom(routeVM.zoom);
        this.zone.run(function () {
            _this.selectMarker(routeVM.route.waypoints[0], 0, routeVM.route.waypoints.length, routeVM.route.name);
        });
    };
    IndexComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeService.getRoots().then(function (routes) {
            var itemspacing = 1000 / (_this.MONTHS.length - 1);
            for (var _i = 0; _i < _this.MONTHS.length; _i++) {
                // TODO: use translations
                var month = _this.MONTHS[_i];
                var timeLineEvent = {
                    left: itemspacing * _i,
                    name: month,
                    number: _i
                };
                _this.timelineEvents.push(timeLineEvent);
            }
            _this.map = new google.maps.Map(document.getElementById('map'), {
                center: new google.maps.LatLng(0, 0),
                zoom: 2,
                minZoom: 1
            });
            for (var _a = 0, routes_1 = routes; _a < routes_1.length; _a++) {
                var route = routes_1[_a];
                _this.drawRout(route);
                _this.routesVM.push({
                    name: route.name,
                    center: route.center,
                    zoom: route.zoom || 3,
                    route: route
                });
            }
            var defaultRoute = routes[0];
            _this.selectMarker(defaultRoute.waypoints[0], 0, defaultRoute.waypoints.length, defaultRoute.name);
        });
    };
    return IndexComponent;
}());
IndexComponent = __decorate([
    core_1.Component({
        selector: 'app-index',
        styles: ["\n        #map {\n            height: 500px;\n        }\n    "],
        template: "\n        <div>\n            <h2 class=\"map-timeline-headline\">\n                <strong>Period:</strong>\n                {{period}}\n            </h2>\n            <div class=\"map-timeline\">\n                <div class=\"map-timeline-waypoints-wrapper\">\n                    <div class=\"map-timeline-waypoints\">\n                        <ol>\n                            <li *ngFor=\"let timelineEvent of timelineEvents; let i = index\">\n                                <span [style.left.px]=\"timelineEvent.left\"\n                                      class=\"map-timeline-waypoint\"\n                                      [ngClass]=\"{'map-timeline-waypoint--selected': timelineEvent.selected }\">\n                                    <div class=\"map-timeline-waypoint-name\">\n                                        {{timelineEvent.name}}\n                                    </div>\n                                </span>\n                            </li>\n                        </ol>\n\n                        <span class=\"map-timeline-progress\" aria-hidden=\"true\"\n                              [style.transform]=\"safeProgress\"></span>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"btn-group map-timeline-routebtns\" role=\"group\">\n                <button *ngFor=\"let route of routesVM;\"\n                        type=\"button\"\n                        class=\"btn btn--sm\"\n                        [ngClass]=\"{'btn--secondary': !route.selected}\"\n                        (click)=\"centerRoute(route)\">\n                    {{route.name}}\n                </button>\n            </div>\n\n            <div id=\"map\"></div>\n\n            <h2 class=\"map-timeline-medien\"><strong>Media for</strong> {{name}}</h2>\n            <slick-slider *ngIf=\"slides\" [slides]=\"slides\">\n            </slick-slider>\n        </div>\n    ",
        providers: [route_service_1.RoutsService]
    })
    // solution from: http://stackoverflow.com/a/38882943/639035
    ,
    __metadata("design:paramtypes", [core_1.NgZone, route_service_1.RoutsService, platform_browser_1.DomSanitizer])
], IndexComponent);
exports.IndexComponent = IndexComponent;


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var SlickSliderComponent = (function () {
    function SlickSliderComponent(el) {
        this.el = el;
        this.changed = false;
        this.defaultOptions = {
            dots: true,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            speed: 200,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 421,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
    }
    SlickSliderComponent.prototype.ngAfterContentInit = function () {
        this.$element = jQuery(this.el.nativeElement);
        this.$element.slick(this.defaultOptions);
        console.log("ngAfterContentInit");
    };
    SlickSliderComponent.prototype.ngOnChanges = function (changes) {
        console.log(changes);
        this.changed = true;
    };
    SlickSliderComponent.prototype.ngAfterViewChecked = function () {
        if (this.changed && this.$element) {
            console.log("slick reinit start: %o", this.$element);
            // we have to remove them like this, because angular can anymore wiht its ngFor
            this.$element.slick('removeSlide', null, null, true);
            // destroy the slider and recreate it
            this.$element.slick("unslick");
            this.$element.slick(this.defaultOptions);
            console.log("slick reinit end");
            this.changed = false;
        }
    };
    return SlickSliderComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], SlickSliderComponent.prototype, "slides", void 0);
SlickSliderComponent = __decorate([
    core_1.Component({
        selector: 'slick-slider',
        template: "\n        <!-- carousel item -->\n        <div class=\"carousel-slider-item\" *ngFor=\"let slide of slides\">\n            <a class=\"highlight-item\" [href]=\"slide.link\" target=\"_blank\">\n                <figure>\n                    <img class=\"carousel-slider-image\" [src]=\"slide.img\" alt=\"Alternative Text\"/>\n\n                    <figcaption>\n                        <!-- overlay -->\n                        <div class=\"highlight-overlay\">\n                            <div class=\"overlay-bg\"></div>\n                            <div class=\"overlay-text-wrapper\">\n                                <h3 class=\"overlay-headline\">{{slide.title}}</h3>\n                            </div>\n                            <div class=\"overlay-sub-text-wrapper\">\n                                <h3 class=\"overlay-sub-headline\">{{slide.subtitle}}\n                                    <span class=\"fa fa-arrow-right\" aria-hidden=\"true\"></span>\n                                </h3>\n                            </div>\n                        </div><!-- ./overlay -->\n                    </figcaption>\n                </figure>\n            </a>\n        </div>\n        <!-- ./carousel item -->\n    "
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], SlickSliderComponent);
exports.SlickSliderComponent = SlickSliderComponent;


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_dynamic_1 = __webpack_require__(83);
var core_1 = __webpack_require__(0);
var app_module_1 = __webpack_require__(213);
core_1.enableProdMode();
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(82);
__webpack_require__(313);
__webpack_require__(314);
var RoutsService = (function () {
    function RoutsService(http) {
        this.http = http;
        this.request = null;
    }
    RoutsService.prototype.getRoots = function () {
        if (this.request == null) {
            this.request = this.http.get('/restservice/routes')
                .map(function (response) {
                return response.json();
            })
                .toPromise();
        }
        return this.request;
    };
    return RoutsService;
}());
RoutsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], RoutsService);
exports.RoutsService = RoutsService;


/***/ })

},[326]);


// WEBPACK FOOTER //
// assets/js/map-timeline/app.bundle.js